<app-centre-small-opener >
		
	<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px" *ngIf="display">{{meetingtitle}}</h2>
	<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px" *ngIf="show">View History</h2>

 
<mat-icon (click)="closeDialog()" class="close-icon" mat-dialog-close>
	close
  </mat-icon>
<div *ngIf="show" contentContainer class="row example-accordion-item-body" >
<table mat-table [dataSource]="dataSource" class="col mat-elevation-z2 demo-table" matSort>
	   
  <!-- Updated By Column -->
  <ng-container matColumnDef="lastModifiedName">
	<th mat-header-cell class="task_header" *matHeaderCellDef> Updated By</th>
	<td mat-cell *matCellDef="let element; let i = index" class="p-24 removeBorder" ><a > {{ i == 0 ? element.lastModifiedBy == undefined ? updatedName : element.lastModifiedBy : element.lastModifiedBy }}</a></td>
  </ng-container>

  <!-- Updated ON Column -->
  <ng-container matColumnDef="lastModifiedOn">
	<th mat-header-cell class="task_header" *matHeaderCellDef> Updated On </th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder"> {{ element.lastModifiedOn | utcDateConverter }} </td>
  </ng-container>
  
  <ng-container matColumnDef="taskTitle" *ngIf="hisEntityType=='AI'">
	<th mat-header-cell class="task_header" *matHeaderCellDef> Task</th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="element.taskTitle"></span> </td>
  </ng-container>


  <ng-container matColumnDef="assignedTo" *ngIf="hisEntityType=='AI'">
	<th mat-header-cell class="task_header" *matHeaderCellDef> AssignedTo</th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder"> {{ element.assignedTo}} </td>
  </ng-container>

  <ng-container matColumnDef="dueDate" *ngIf="hisEntityType=='AI'">
	<th mat-header-cell class="task_header" *matHeaderCellDef> Due Date</th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder"> {{ element.dueDate}} </td>
  </ng-container>

  <ng-container matColumnDef="status" *ngIf="hisEntityType=='AI'">
	<th mat-header-cell class="task_header" *matHeaderCellDef>Status</th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder"> {{ element.status}} </td>
  </ng-container>

  <!-- Discription Column -->
  <ng-container matColumnDef="noteDescription" contenteditable="true">
	<th mat-header-cell class="task_header" *matHeaderCellDef> Description </th>
	<td mat-cell *matCellDef="let element" class="p-24 removeBorder" contenteditable="true"><span class="taskTitles" contenteditable="true" [innerHtml] = "element.noteDescription == undefined ? element.taskTitle : element.noteDescription"></span></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr [ngClass] = "row.existing ? 'left-border' : '' " mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>

<div contentContainer *ngIf="display" class="row example-accordion-item-body">
	<div>
		<!-- <label  style="font-size: 16px; margin-right: 10px;"></label>
		<select name="" id="history" (change)="filterCondition($event)" style="width: 200px; font-size: 16px;" required>
			<option value="select" selected>Select</option>
			<option *ngFor="let data of arr" [value]="data">{{data}}</option>
		</select> -->


		<mat-form-field appearance="outline" style="margin-right: 20px;">
			<mat-label>History</mat-label>
			<mat-select (selectionChange)="filterCondition($event)"  required [(value)]="hisselected">
			  <mat-option *ngFor="let data of arr" [value]="data">
				{{data}}
			  </mat-option>
			</mat-select>     
		  </mat-form-field>
		  <!-- <span>

		  </span> -->
			<!-- <mat-form-field appearance="outline">
			  <mat-label>Filter</mat-label>
			  <mat-select (selectionChange)="filterCondition($event)" required>
				<mat-option  *ngFor="let Filterdata of filterOptions" [value]="Filterdata">
				  {{Filterdata}}
				</mat-option>
			  </mat-select>     
			</mat-form-field> -->
		   <!-- <mat-form-field appearance="outline">
			 <mat-label>History</mat-label>
			 <mat-select (selectionChange)="filterCondition($event)" required>
			   <mat-option *ngFor="let data of arr" [value]="data">{{data}}
			   </mat-option>
			 </mat-select>  -->
		  
		</div>
		  
<div contentContainer class="row example-accordion-item-body" >
  <table   class="col mat-elevation-z2 demo-table" *ngIf="selectedReport == 'Meeting'">
	<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Meeting History</h2>
	<tr >
		<th class="task_header w-20"><strong>Type</strong></th>
		<th class="task_header w-20"><strong>Who</strong></th>
		<th class="task_header w-20"><strong>When</strong></th>
		<th class="task_header w-40"><strong>Value</strong></th>
	</tr>
		<tr *ngFor="let indexobj of agendaSource">
			<td class="p-24 removeBorder">{{indexobj.location!=null  ? "Location" : indexobj.approvalHours!=null ? "Approval Hours" : indexobj.meetingTitle!=null ? "Meeting Title":indexobj.isConfidential!=null ? "Is Confidential":indexobj.meetingType!=null ? "Meeting Type":indexobj.meetingDate!=null ? "Meeting Date":indexobj.meetingStartFlag!=null ? "Meeting Started":indexobj.meetingEndFlag!=null ? "Meeting Ended":''}}</td>
			<td class="p-24 removeBorder">{{indexobj.lastModifiedBy}}</td>
			<td class="p-24 removeBorder">{{indexobj.lastModifiedOn | utcDateConverter}}</td>
			<td class="p-24 removeBorder">{{indexobj.location!=null  ? indexobj.location : indexobj.approvalHours!=null ? indexobj.approvalHours : indexobj.meetingTitle!=null ? indexobj.meetingTitle :indexobj.isConfidential!=null ? indexobj.isConfidential:indexobj.meetingType!=null ? indexobj.meetingType:indexobj.meetingDate!=null ? indexobj.meetingDate:indexobj.meetingStartFlag!=null ? indexobj.meetingStartFlag:indexobj.meetingEndFlag!=null ? indexobj.meetingEndFlag:''}}</td>
		</tr>	 
		
	 </table> 
	</div>
	<div contentContainer class="row example-accordion-item-body" >
		<table   class="col mat-elevation-z2 demo-table" *ngIf="selectedReport == 'Attendee'">
			<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Attendee History</h2>
			
		  <tr >
			<th class="task_header w-20"><strong>Attendee Name</strong></th>
		  <!-- <th class="task_header w-20"><strong>Field</strong></th> -->
			<th class="task_header w-20"><strong>Who </strong></th>
			<th class="task_header w-20"><strong>When </strong></th>
			<th class="task_header w-10"><strong>Value</strong></th>	

		</tr>
		<div *ngIf="AttendeeSource?.length === 0">
			<span>No History Records Found</span>
		  </div> 
		<tr *ngFor="let attendee of AttendeeSource"  >
			<td class="p-24 removeBorder">{{attendee.attendeeName }}-{{attendee.attendeeRoleCode!=null ? "Role" : attendee.attendeeIsPresent!=null ? "Present":''}}</td>
			<!-- <td class="p-24 removeBorder">{{attendee.attendeeRoleCode!=null ? "Attendee RoleCode" : attendee.attendeeIsPresent!=null ? "Attendee IsPresent":''}}</td> -->
			<td class="p-24 removeBorder">{{attendee.lastModifiedBy}}</td>
			<td class="p-24 removeBorder">{{attendee.lastModifiedOn | utcDateConverter}}</td> 
			<td class="p-24 removeBorder">{{ attendee.attendeeRoleCode!=null ? attendee.attendeeRoleCode : attendee.attendeeIsPresent!=null ? attendee.attendeeIsPresent :""}}</td>
		</tr>
	 </table> 
		  </div>
		  <div *ngIf="selectedReport == 'Agenda'" >
		  <div contentContainer class="row example-accordion-item-body" *ngFor="let agenda of agendaSource1 ; let index=index">
			<table   class="col mat-elevation-z2 demo-table" >
				<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">{{agenda.agendaDetails.agendaTitle}}</h2>
				<tr >
				<th class="task_header w-20" ><strong>Type </strong></th>
				<th class="task_header w-20"><strong>Who </strong></th> 
				<th class="task_header w-20"><strong>When</strong></th> 
				<th class="task_header w-20" ><strong>Value </strong></th>
			</tr>
			<div *ngIf="agenda.agendaHistory==0">
				<span>No History Records Found</span>
			</div> 
			<tr  *ngFor="let agen of agenda.agendaHistory">
				<ng-container >
				<td class="p-24 removeBorder">{{agen.agendaTitle!=null  ? "AgendaTitle" : agen.agendaDuration!=null ? "Agenda Duration" : agen.createdOn!=null ? "Created On":agen.agendaSequence!=null ? "agendaSequence":agen.agendaCompleteFlag!=null ?"agenda CompleteFlag" :''}}</td>
				<td class="p-24 removeBorder">{{agen.lastModifiedBy}}</td>
				<td class="p-24 removeBorder">{{agen.lastModifiedOn | utcDateConverter}}</td> 
				<td class="p-24 removeBorder">{{agen.agendaTitle!=null  ? agen.agendaTitle : agen.agendaDuration!=null ? agen.agendaDuration : agen.createdOn!=null ? agen.createdOn:agen.agendaSequence!=null ? agen.agendaSequence:agen.agendaCompleteFlag!=null ?agen.agendaCompleteFlag :''}}</td>
				</ng-container>
			</tr>
		 </table> 
	  </div>	
	</div>
<div *ngIf="selectedReport == 'Note'" >
<div contentContainer class="row example-accordion-item-body"  *ngFor="let agenda of NoteSource ; let index=index" >
<table  class="col mat-elevation-z2 demo-table">
	<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">{{agenda.agendaDetails.agendaTitle}}</h2>
	<tr >
	<th class="task_header w-20" ><div  >Who </div></th>
	<th class="task_header w-20" ><div  >When </div></th>
	<th class="task_header w-40" ><div  >Description</div></th>
</tr>
<div *ngIf="agenda.minutesHistory[0].noteHistory.length==0">
	<span>No History Records Found</span>
  </div> 
<tr *ngFor="let data of agenda.minutesHistory[0].noteHistory">	
	<td  class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedBy}}</td>
	<td  class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
	<td  class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='emptySpace' ? ' ---- ' : data.noteDescription"></span></td>
	</tr>
	</table>
 <!-- </div>  -->

</div>
</div>
<div *ngIf="selectedReport == 'Task'" >
	<div contentContainer class="row example-accordion-item-body" *ngFor="let agTaskList of TaskSource ; let index=index">
	<table  class="col mat-elevation-z2 demo-table" >
		<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">{{agTaskList.agendaDetails.agendaTitle}}</h2>
		<tr >
		<th class="task_header w-15"><strong>Who</strong></th>
		<th class="task_header w-10"><strong>When</strong></th>
		<th class="task_header w-40"><strong>Description</strong></th>
		<th class="task_header w-15"><strong>Assigned To</strong></th>
		<th class="task_header w-10"><strong>Due Date</strong></th>
		<th class="task_header w-10"><strong>Status</strong></th>
	</tr>
	<div *ngIf="agTaskList.minutesHistory[0].taskHistory.length==0">
		<span>No History Records Found</span>
	  </div> 
	<tr *ngFor="let data of agTaskList.minutesHistory[0].taskHistory">
		<ng-container >
		<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.lastModifiedBy}}</td>
		<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
		<td class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='firstId' ? ' ---- ' : data.taskTitle"></span></td>
		<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.assignedTo}}</td>
		<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.dueDate}}</td>
		<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.status}}</td>
	</ng-container>
	</tr>
	</table> 
	<!-- </div> -->
	
	</div>
	</div>
	<div *ngIf="selectedReport == 'Decision'" >
		<div contentContainer class="row example-accordion-item-body" *ngFor="let agDecisionList of DecisionSource ; let index=index">
		<table   class="col mat-elevation-z2 demo-table"   >
			<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">{{agDecisionList.agendaDetails.agendaTitle}}</h2>
			<tr >
			<th class="task_header w-20"><strong>Who  </strong></th>
			<th class="task_header w-20"><strong>When </strong></th>
			<th class="task_header w-40"><strong>Description</strong></th>
		</tr>
		<div *ngIf="agDecisionList.minutesHistory[0].decisionHistory.length==0">
			<span class= "d-flex align-items-center">No History Records Found</span>
		  </div> 
		<tr *ngFor="let data of agDecisionList.minutesHistory[0].decisionHistory">
			<ng-container *ngIf="data!=null" >
			<td class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedBy}}</td>
			<td class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
			<td class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='emptySpace' ? ' ---- '  : data.noteDescription"></span></td>
			</ng-container>
		</tr>
		</table>
	  <!-- </div> -->
		 
		</div>
	</div>
		<div contentContainer class="row example-accordion-item-body" *ngFor="let indexvalue of agendaSource; let index=index"> 
			<!-- <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px" *ngIf="indexvalue.key=='note'">MinutesHistory of agenda</h2>  -->
				<div *ngIf="selectedReport == 'All'">
			<div *ngIf="index==0 && indexvalue[0]!=null ">
				<table   class="col mat-elevation-z2 demo-table" > 
					<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Meeting History</h2>
				<tr >
					<th class="task_header w-20"><strong>Type</strong></th>
					<th class="task_header w-20"><strong>Who</strong></th>
					<th class="task_header w-20"><strong>When</strong></th>
					<th class="task_header w-40"><strong>Value</strong></th>
				</tr>
				<div *ngIf="indexvalue.length==0">
					<span>No History Records Found</span>
				</div> 
				<tr *ngFor="let indexobj of indexvalue">
					<td class="p-24 removeBorder">{{indexobj.location!=null  ? "Location" : indexobj.approvalHours!=null ? "Approval Hours" : indexobj.meetingTitle!=null ? "Meeting Title":indexobj.isConfidential!=null ? "Is Confidential":indexobj.meetingType!=null ? "Meeting Type":indexobj.meetingDate!=null ? "Meeting Date":indexobj.meetingStartFlag!=null ? "Meeting Started":indexobj.meetingEndFlag!=null ? "Meeting Ended":''}}</td>
					<td class="p-24 removeBorder">{{indexobj.lastModifiedBy}}</td>
					<td class="p-24 removeBorder">{{indexobj.lastModifiedOn | utcDateConverter}}</td>
					<td class="p-24 removeBorder">{{indexobj.location!=null  ? indexobj.location : indexobj.approvalHours!=null ? indexobj.approvalHours : indexobj.meetingTitle!=null ? indexobj.meetingTitle :indexobj.isConfidential!=null ? indexobj.isConfidential:indexobj.meetingType!=null ? indexobj.meetingType:indexobj.meetingDate!=null ? indexobj.meetingDate:indexobj.meetingStartFlag!=null ? indexobj.meetingStartFlag:indexobj.meetingEndFlag!=null ? indexobj.meetingEndFlag:''}}</td>
				</tr>	 
			</table>
			</div>
			<div *ngIf="index==1 && indexvalue[1]!=null ">	
			<table   class="col mat-elevation-z2 demo-table" >
				<h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Attendee History</h2>
				<tr >
					<th class="task_header w-20"><strong>Attendee Name</strong></th>
					<th class="task_header w-20"><strong>Who </strong></th>
					<th class="task_header w-20"><strong>When </strong></th>
					<th class="task_header w-10"><strong>Value</strong></th>	
				</tr>
				<div *ngIf="indexvalue.length==0">
					<span>No History Records Found</span>
				</div> 
				<tr *ngFor="let attendee of indexvalue"  >
					<ng-container >
						<td class="p-24 removeBorder">{{attendee.attendeeName!=null  ? attendee.attendeeName : attendee.attendeeRoleCode!=null ? "Attendee RoleCode" : attendee.logType!=null ? "Log Type":attendee.createdOn!=null ? "CreatedOn":''}}</td>
						<td class="p-24 removeBorder">{{attendee.lastModifiedBy}}</td>
						<td class="p-24 removeBorder">{{attendee.lastModifiedOn | utcDateConverter}}</td> 
						<td class="p-24 removeBorder">{{attendee.attendeeName!=null  ? attendee.attendeeName : attendee.attendeeRoleCode!=null ? attendee.attendeeRoleCode : attendee.logType!=null ? attendee.logType:attendee.createdOn!=null ? attendee.createdOn:''}}</td>
					</ng-container>
				</tr>
			</table>
			</div>
			</div>
		</div>
			<div contentContainer class="row example-accordion-item-body" *ngIf="selectedReport == 'All' && agendaSource[2]!=null" >
				<div *ngFor="let agenda of agendaSource[2] ; let agindex = index;" >
					    <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px" >{{agenda.agendaDetails.agendaTitle}}</h2>
						<table   class="col mat-elevation-z2 demo-table"  >
						<tr >
							<th class="task_header w-20" ><strong>Type </strong></th>
							<th class="task_header w-20"><strong>Who </strong></th> 
							<th class="task_header w-20"><strong>When </strong></th> 
							<th class="task_header w-20" ><strong>Value </strong></th>
						</tr>
						<div *ngIf="agenda.agendaHistory.length==0">
							<span>No History Records Found</span>
						</div> 
						<tr  *ngFor="let agen of agenda.agendaHistory">
							<ng-container >
								<td class="p-24 removeBorder">{{agen.agendaTitle!=null  ? "AgendaTitle" : agen.agendaDuration!=null ? "Agenda Duration" : agen.createdOn!=null ? "CreatedOn":agen.agendaSequence!=null ? "agenda Sequence":agen.agendaCompleteFlag!=null ?"agenda CompleteFlag" :''}}</td>
								<td class="p-24 removeBorder">{{agen.lastModifiedBy}}</td>
								<td class="p-24 removeBorder">{{agen.lastModifiedOn | utcDateConverter}}</td> 
								<td class="p-24 removeBorder">{{agen.agendaTitle!=null  ? agen.agendaTitle : agen.agendaDuration!=null ? agen.agendaDuration : agen.createdOn!=null ? agen.createdOn:agen.agendaSequence!=null ? agen.agendaSequence:agen.agendaCompleteFlag!=null ?agen.agendaCompleteFlag :''}}</td>
							</ng-container>
						</tr>
					</table>
				

					<!-- <div *ngIf="showMinutes.includes(agenda.agendaTitle) && agenda!=null"> -->
						
					<div *ngFor="let minutes of agenda.minutesHistory; let index = index;">
					<table  class="col mat-elevation-z2 demo-table">
						<h3 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Note History</h3>
					<tr >
						<th class="task_header w-20" ><div>Who </div></th>
						<th class="task_header w-20" ><div>When </div></th>
						<th class="task_header w-40" ><div>Description</div></th>
					</tr>
					<div *ngIf="minutes.noteHistory.length==0">
						<span class= "d-flex align-items-center">No History Records Found</span>
					  </div> 
					<tr *ngFor="let data of minutes.noteHistory">	
						<td  class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedBy}}</td>
						<td  class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
						<td  class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='emptySpace' ? ' ---- ' : data.noteDescription"></span></td>
			
					</tr>
					
					</table>
					<table  class="col mat-elevation-z2 demo-table">
						<h3 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Decision History</h3>
					<tr >
						<th class="task_header w-20"><strong>Who</strong></th>
						<th class="task_header w-20"><strong>When</strong></th>
						<th class="task_header w-40"><strong>Description</strong></th>
						
					</tr>
					<div *ngIf="minutes.decisionHistory.length==0">
						<span class= "d-flex align-items-center">No History Records Found</span>
					  </div>
					<tr *ngFor="let data of minutes.decisionHistory">
						<ng-container *ngIf="data!=null" >
						<td class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedBy}}</td>
						<td class="p-24 removeBorder">{{data=='emptySpace' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
						<td class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='emptySpace' ? ' ---- '  : data.noteDescription"></span></td>
						</ng-container>
					</tr>
					</table>
					<table  class="col mat-elevation-z2 demo-table">
						<h3 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Task History</h3>
					<tr >
						<th class="task_header w-10"><strong>Who </strong></th>
						<th class="task_header w-15"><strong>When </strong></th>
						<th class="task_header w-40"><strong>Description</strong></th>
						<th class="task_header w-15"><strong>Assigned To</strong></th>
						<th class="task_header w-10"><strong>Due Date</strong></th>
						<th class="task_header w-10"><strong>Status</strong></th>
					</tr>
					<div *ngIf="minutes.taskHistory.length==0">
						<span class= "d-flex align-items-center">No History Records Found</span>
					  </div> 
					<tr *ngFor="let data of minutes.taskHistory">
						<ng-container >
						<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.lastModifiedBy}}</td>
						<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.lastModifiedOn | utcDateConverter}}</td>
						<td class="p-24 removeBorder"><span class="taskTitles" contenteditable="false" [innerHTML]="data=='firstId' ? ' ---- ' : data.taskTitle"></span></td>
						<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.assignedTo}}</td>
						<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.dueDate}}</td>
						<td class="p-24 removeBorder">{{data=='firstId' ? " ---- " : data.status}}</td>
					</ng-container>
					</tr>
					</table>
				</div>
				<!-- </div> -->
				
				
				</div>
				</div>
				</div>
				
			</app-centre-small-opener>
				
				<!-- <div>
					<div  class="footer container-fluid" >            
						<app-footer></app-footer>
					  </div>
				</div>		 -->
	<!-- </mat-form-field> -->



